import { download } from '@/utils/utils'

export default {
  created () {
    this.singleActions = [
      {
        label: '下载',
        action: obj => {
          download(obj.license_content, `${obj.service_type}.${this.$moment(obj.expire).format('YYYY-MM-DD')}.lic`)
        },
      },
    ]
  },
}
